module.exports = __webpack_public_path__ + "assets/img/tx102z_3.2f0ae76b.jpg";